<!-- Contact Section -->
 <app-breadcrumb currentPage="Contact"></app-breadcrumb>
<section id="contact" class="contact">

  <!-- Section Title -->
  <div class="contact-sec" data-aos="fade-up">
    <span class="badge-label">Let's Talk About Your Project</span>
    <!-- <h2>Contact</h2> -->
    <!-- <h3>Let's Talk About Your Project</h3> -->
    <h2>Have an idea, a business requirement, or an existing application that needs improvement?</h2>
    <div class="contact-sec-text">
      <p>Tell us what you're looking to build, improve, or maintain. Our team will review your requirements and get back to you with the next steps.</p>
    </div>
  </div><!-- End Section Title -->

  <div class="container" data-aos="fade-up" data-aos-delay="100">

    <div class="row g-4 mb-5">
      <div class="col-lg-4 col-md-6" data-aos="fade-down" data-aos-delay="150">
        <div class="reach-card">
          <div class="reach-icon-wrap">
            <i class="bi bi-envelope-at"></i>
          </div>
          <h5>Drop a Line</h5>
          <p>info@splexinov.com, sales@splexinov.com</p>
          <span class="reach-note">We typically respond within 3–5 business hours.</span>
        </div><!-- End Reach Card -->
      </div>

      <div class="col-lg-4 col-md-6" data-aos="fade-down" data-aos-delay="250">
        <div class="reach-card">
          <div class="reach-icon-wrap">
            <i class="bi bi-telephone"></i>
          </div>
          <h5>Give Us a Ring</h5>
          <p>+91 9535857777, +91 6309597788, +91 6302001630</p>
          <span class="reach-note">Weekdays | 9:00 AM – 7:00 PM IST</span>
        </div><!-- End Reach Card -->
      </div>

      <div class="col-lg-4 col-md-12" data-aos="fade-down" data-aos-delay="350">
        <div class="reach-card">
          <div class="reach-icon-wrap">
            <i class="bi bi-geo-alt"></i>
          </div>
          <h5>Visit Us</h5>
          <p>Bengaluru, Karnataka, India</p>
          <span class="reach-note">Monday – Friday | 9:00 AM – 5:00 PM IST</span>
        </div><!-- End Reach Card -->
      </div>
    </div>

    <div class="row g-0 form-info-wrapper" data-aos="fade-up" data-aos-delay="200">
      <div class="col-lg-5">
        <div class="info-panel">
          <div class="panel-content">
            <h3>Let's Build Something That Works for Your Business.</h3>
            <p class="text-left">Have an idea, a project, or a business challenge? Let's discuss it.</p>
            <p class="text-left">From websites and software applications to SaaS solutions, integrations, and ongoing support, we provide practical technology solutions designed around your business needs.</p>

            <div class="panel-stats" data-aos="zoom-in" data-aos-delay="300">
              <div class="row g-3">
                <div class="col-12">
                  <div class="single-stat">
                    <strong>Clear Communication</strong>
                    <span>Understand your requirements before we begin.</span>
                  </div>
                </div>
                <div class="col-12">
                  <div class="single-stat">
                    <strong>Reliable Delivery</strong>
                    <span>Build solutions around agreed scope and expectations.</span>
                  </div>
                </div>
                <div class="col-12">
                  <div class="single-stat">
                    <strong>Ongoing Support</strong>
                    <span> Continue supporting and improving your technology after launch.</span>
                  </div>
                </div>
              </div>
            </div><!-- End Stats -->

            <div class="panel-social" data-aos="fade-up" data-aos-delay="400">
              <span>Follow Our Journey</span>
              <div class="social-icons">
                <a href="https://www.linkedin.com/company/splex-innovation?trk=blended-typeahead" target="_blank" rel="noopener noreferrer"><i class="bi bi-linkedin"></i></a>
                <!-- <a href="#"><i class="bi bi-twitter-x"></i></a>
                <a href="#"><i class="bi bi-github"></i></a>
                <a href="#"><i class="bi bi-discord"></i></a> -->
              </div>
            </div><!-- End Social -->
          </div>
        </div>
      </div>

      <div class="col-lg-7">
        <div class="form-panel">
          <div class="form-intro">
            <!-- <i class="bi bi-pencil-square"></i> -->
            <h3>Share Your Thoughts</h3>
            <p>Have a project in mind? Share your requirements with us, and our team will get back to you shortly.</p>
          </div>

          <form id="contact-form" (submit)="sendEmail($event)" class="php-email-form">
            <div class="row g-3">
              <div class="col-sm-6">
                <label class="form-label">Full Name</label>
                <input type="text" name="user_name" class="form-control" placeholder="Enter your full name" required="">
              </div>
              <div class="col-sm-6">
                <label class="form-label">Email Address</label>
                <input type="email" name="user_email" class="form-control" placeholder="Enter your business email" required=""
                  >
              </div>
              <div class="col-sm-6">
                <label class="form-label">Organization</label>
                <input type="text" name="topic" class="form-control" placeholder="Enter your organization name" required="">
              </div>
              <div class="col-sm-6">
                <label class="form-label">Contact Number</label>
                <input type="text" name="contact_number" class="form-control" placeholder="Enter your contact number" required="">
              </div>
              <div class="col-12">
                <label class="form-label">Requirements</label>
                <textarea name="message" class="form-control" rows="5"
                  placeholder="Describe your project or inquiry in detail..." required=""></textarea>
              </div>
            </div>

            <div class="my-3">
              <div class="loading">Loading</div>
              <div class="error-message"></div>
              <div class="sent-message">Your message has been sent. Thank you!</div>
            </div>

            <button type="submit" class="dispatch-btn">
              <i class="bi bi-arrow-right-circle-fill"></i>
              <span>Send Enquiry</span>
            </button>
          </form>
        </div>
      </div>
    </div><!-- End Form & Info Wrapper -->

  </div>

</section><!-- /Contact Section -->